import React from "react";
import { Container, Paper, Grid } from "@mui/material";
import HomeSearch from "./HomeSearch";
import assessorinfo from "../../images/assessorinfo.jpg";
import classes from "./styles.module.css";

const Home = () => {
  return (
    <Container component="main" maxWidth="xl">
      <Paper className={classes.paper} elevation={3}>
        <Grid container spacing={1} alignItems="center">
          <Grid item md={0.5} xs={12}></Grid>
          <Grid item md={4.5} xs={12}>
            <h4>
              Assessor Info, free software to connect to public records and
              geographic information (parcel boundaries) from your County,
              Township, and/or Parish Assessor Office. In addition, the software
              is a free hosting service for officials wanting to participate in
              sharing data to corporations, general public, local, state, and
              federal entities. Features available, but not limited too, are:
              sales comparison report, data export, ratio study charts, and
              property characteristic reports. The information is free and can
              be accessed 24/7 from your computer, tablet, or mobile device.
              Please select an available jurisdiction in the dropdown to begin.{" "}
            </h4>
            <br />
            <HomeSearch />
          </Grid>
          <Grid item md={0.5} xs={12}></Grid>
          <Grid item md={6.5} xs={12}>
            <img src={assessorinfo} width="100%" />
          </Grid>
        </Grid>
      </Paper>
    </Container>
  );
};

export default Home;
